<template>
  <div>
    <h4 class="has-text-centered is-size-6 has-text-weight-semibold">
      Empresas de servicio más redimidas
    </h4>
    <div v-if="mountGraphic">
      <BarChart :information="company" :values="values" label="Redenciones" />
    </div>
    <div v-else class="has-text-centered mt-5">
      Cargando gráfico de empresas de servicio ...
    </div>
    <hr />
  </div>
</template>

<script>
import BarChart from "@/components/graphics/BarChart";
import GraphicService from "@/services/GraphicService";
export default {
  components: {
    BarChart
  },
  data() {
    return {
      results: [],
      company: [],
      values: [],
      mountGraphic: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const response = await GraphicService.getCompany();
        this.results = response.data;
        for (let i = 0; i < this.results.length; i++) {
          this.company.push(this.results[i].business_name);
          this.values.push(this.results[i].total);
        }
        setTimeout(() => {
          this.mountGraphic = true;
        }, 500);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
